/**
 * <h4>Recommendation errors</h4>
 *
 * @packageDocumentation
 */
export { RecommendationError } from './RecommendationError'
